export enum DocumentStatus {
  PUBLISH = "publish",
  UNPUBLISH = "unpublish",
}

export enum DocumentFlag {
  ABOUTUS = "about_us",
  RESOURCE = "resource",
  IMPORT = "import",
  EXPORT = "export",
}

export type DocumentQueryModel = {
  flag: DocumentFlag;
  page: number;
  limit: number;
};

export type DocumentInputModel = {
  status: DocumentStatus;
  file: any;
  flag: DocumentFlag;
};

export type DocumentOutputModel = {
  id: string;
  name: string;
  status: DocumentStatus;
  file: any;
  flag: DocumentFlag;
};